import React from 'react';
import { Box } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { boxStyles } from '../constants/styles';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { BoxLoader } from './common/box-loader';
import { CollapsibleSummaryLoader } from './common/collapsible-summary-loader';
import { TotalCountSectionLoader } from './common/total-count-section-loader';

const renderBillingProfileSection = () => {
  const cellMarginRight = '3%';
  const cellContentWidth = '17%';
  const headingCellMarginRight = '8%'; // cellContentWidth - 12% {heading cell width} + cellMarginRight
  const cell = <SkeletonLoader width="12%" marginBottom="8px" marginRight={headingCellMarginRight} />;

  return (
    <Box padding="space.250" xcss={boxStyles}>
      <>
        {/* Row 1 */}
        <SkeletonLoaderWrapper>{cell}</SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width={cellContentWidth} />
        </SkeletonLoaderWrapper>
      </>
      <>
        {/* Row 2 */}
        <SkeletonLoaderWrapper>{Array.from({ length: 3 }).map((_) => cell)}</SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width={cellContentWidth} height="100px" marginRight={cellMarginRight} />
          <SkeletonLoader width={cellContentWidth} height="100px" marginRight={cellMarginRight} />
          <SkeletonLoader width={cellContentWidth} height="100px" marginRight={cellMarginRight} />
        </SkeletonLoaderWrapper>
      </>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="70%" marginBottom="0" />
      </SkeletonLoaderWrapper>
    </Box>
  );
};

const renderRefundsSection = () => {
  return (
    <>
      <SkeletonLoaderWrapper>
        {/* Refunds heading */}
        <SkeletonLoader width="10%" />
      </SkeletonLoaderWrapper>
      <TableLoader hideSearchBar hideFilters hideActions columnsCount={3} shouldRightAlignLastCol />
    </>
  );
};

export const InvoiceDetailsPageLoader = ({ shouldHideRefunds }: { shouldHideRefunds?: boolean }) => {
  return (
    <div className="pl-8">
      <PageHeaderLoader />
      <BoxLoader columnsCount={4} shouldRightAlignLastCol />
      <CollapsibleSummaryLoader rowsCount={4} />
      {renderBillingProfileSection()}
      <br />
      <br />
      <TableLoader hideSearchBar hideFilters hideActions columnsCount={6} />
      <br />
      <TotalCountSectionLoader />
      <br />
      {shouldHideRefunds || (
        <>
          {renderRefundsSection()}
          <br />
        </>
      )}
    </div>
  );
};
